const translation = {
  custom: 'Prilagoditev',
  upgradeTip: {
    prefix: 'Nadgradite svoj načrt za',
    suffix: 'prilagoditev vaše blagovne znamke.',
    des: 'Nadgradite svoj načrt, da prilagodite svojo blagovno znamko',
    title: 'Nadgradite svoj načrt',
  },
  webapp: {
    title: 'Prilagodi blagovno znamko spletne aplikacije',
    removeBrand: 'Odstrani Powered by Dify',
    changeLogo: 'Spremeni sliko Powered by Brand',
    changeLogoTip: 'Format SVG ali PNG z minimalno velikostjo 40x40px',
  },
  app: {
    title: 'Prilagodi blagovno znamko glave aplikacije',
    changeLogoTip: 'Format SVG ali PNG z minimalno velikostjo 80x80px',
  },
  upload: 'Naloži',
  uploading: 'Nalagam',
  uploadedFail: 'Nalaganje slike ni uspelo, prosimo, poskusite znova.',
  change: 'Spremeni',
  apply: 'Uporabi',
  restore: 'Obnovi privzete nastavitve',
  customize: {
    contactUs: ' kontaktirajte nas ',
    prefix: 'Za prilagoditev logotipa blagovne znamke znotraj aplikacije, prosimo,',
    suffix: 'za nadgradnjo na Enterprise izdajo.',
  },
}

export default translation
